import { createDeepEqualSelector, type RootState } from "../../entities";

import {
  OnboardingPromptStatus,
  type OnboardingPrompt,
  type OnboardingEventNameType,
} from "./types";

export const allOnboardingItemsComplete = (
  prompts: OnboardingPrompt[],
): boolean => {
  return (
    prompts.length > 0 &&
    prompts.every(({ status }) => status === OnboardingPromptStatus.completed)
  );
};

export const selectOnboardingData = (state: RootState) => {
  return state.onboarding;
};

export const selectOnboardingBlacklist = (state: RootState) => {
  return state.onboarding.eventNameBlacklist;
};

export const selectAllOnboardingItemsComplete = (state: RootState) => {
  return allOnboardingItemsComplete(state.onboarding.prompts);
};

export const selectHasOnboardingItems = (state: RootState) => {
  return state.onboarding.prompts.length > 0;
};

export const selectPromptByEventName = createDeepEqualSelector(
  [selectOnboardingData, (_, eventName: OnboardingEventNameType) => eventName],
  ({ prompts }, eventName) => {
    return prompts.find((prompt) => prompt.event_name === eventName);
  },
);
